/**
 * Created by mac on 12/8/20
 */

const ViewReader = {}; 

ViewReader.calcBorderType = function (map, part) {
    const tilesTexture = Map2d.getTilesTexture(map.tilesSkin);
    this.unused = Object.keys(bundles[tilesTexture].frames).filter((name) => name.includes("land") || name.includes("water1") || name.includes("water2"));

    const level1Area = map.map(map.layers[Map2d.LAYER_GROUND], (tile, x, y) => map.calcGroundLevel(x, y) === Map2d.TILE_GREEN_LEVEL_1);

    const level2Area = map.map(map.layers[Map2d.LAYER_GROUND], (tile, x, y) => map.calcGroundLevel(x, y) === Map2d.TILE_GREEN_LEVEL_2);
    BorderRenderer.place(
        level2Area,
        ViewReader.bordersPlacement.bind(this),
        { part }
    );

    BorderRenderer.place(
        level1Area,
        ViewReader.bordersPlacement.bind(this),
        { part }
    );
};

ViewReader.onEdit = function (x, y) {
    const neighbours = BorderRenderer.getNeighbours(x, y).concat({ x, y });

    neighbours.forEach((neighbour) => {
        Map2d.currentMap.remove(Map2d.LAYER_BORDERS, neighbour.x, neighbour.y);
    });

    ViewReader.calcBorderType(Map2d.currentMap, neighbours);
};

ViewReader.customSkipWall = function (cell, border) {
    const map = Map2d.currentMap;
    const customTypes = ["tiles_castle_purple"];
    if (!customTypes.includes(map.getTerrainType(cell.x, cell.y).name)) {
        return false;
    }

    const borderCellLevel = map.calcGroundLevel(border.borderCell.x, border.borderCell.y);
    if (["up_left", "down_right", "up_right", "down_left"].includes(border.name) && borderCellLevel === Map2d.TILE_WATER) { // https://gyazo.com/a48c44f9b4cfa3004be3127ea88eb9fa
        if (border.noNeighbor.some((side) => {
            const sideCell = BorderRenderer.getNeighbor(cell.x, cell.y, side);
            return map.calcGroundLevel(sideCell.x, sideCell.y) !== borderCellLevel;
        })) {
            return true;
        }
    }

    if (["right", "up"].includes(border.name)) { // https://gyazo.com/48401a356db80941e3b6aa6d87669a8a, https://gyazo.com/5549179438f4f51e2bbce44a326051ce
        const checked = [cell, BorderRenderer.getNeighbor(cell.x, cell.y, border.name === "right" ? "up" : "right")];
        for (let i = 0; i < checked.length; i++) {
            const checkCell = BorderRenderer.getNeighbor(checked[i].x, checked[i].y, "up_right");
            if (map.getValue(Map2d.LAYER_GROUND, checkCell.x, checkCell.y) && !map.getValue(Map2d.LAYER_BORDERS, checkCell.x, checkCell.y)) {
                return true;
            }
        }
    }
};

ViewReader.bordersPlacement = function (borders, cell) {
    const map = Map2d.currentMap;
    const cellLevel = map.calcGroundLevel(cell.x, cell.y);

    if (map.getValue(Map2d.LAYER_BORDERS, cell.x, cell.y)) {
        return;
    }

    borders.forEach((border) => {
        const borderCell = border.borderCell;
        const borderCellLevel = map.calcGroundLevel(borderCell.x, borderCell.y);
        if (!map.isValid(borderCell.x, borderCell.y)) {
            return;
        }

        const surface = borderCellLevel === Map2d.TILE_WATER ? "water" : "land";
        let level = `${cellLevel}_`;
        const direction = border.name;
        let suffix = "";

        if (ViewReader.customSkipWall(cell, border)) {
            return;
        }

        if (["up", "right"].includes(border.name)
            && borders.some((border) => border.name === "up_right") && map.getTerrainFrameData("water1_up_right", cell.x, cell.y).res) {
            return;
        }

        if (["left", "down", "inner_up_right", "inner_down_left"].includes(border.name)) {
            const checkCell = BorderRenderer.getNeighbor(borderCell.x, borderCell.y, "up_right");
            const upperCellLevel = map.calcGroundLevel(checkCell.x, checkCell.y);
            if (cellLevel !== upperCellLevel) {
                suffix = "_last";
            }
        }

        let frameName = surface + level + direction + suffix;
        let frameData = map.getTerrainFrameData(frameName, cell.x, cell.y);

        if (!frameData.res && suffix) {
            suffix = "";
            frameName = surface + level + direction + suffix;
            frameData = map.getTerrainFrameData(frameName, cell.x, cell.y);
        }

        if (!frameData.res) {
            level = "1_";
            frameName = surface + level + direction + suffix;
            frameData = map.getTerrainFrameData(frameName, cell.x, cell.y);
        }

        if (!frameData.res) {
            return;
        }
        
        frameData.type = border.name;

        const borderTile = map.getValue(Map2d.LAYER_BORDERS, borderCell.x, borderCell.y) || new BorderTile(borderCell.x, borderCell.y);
        borderTile.addBorder(frameData);
        if (this.unused && this.unused.includes(frameData.res.key)) {
            this.unused.splice(this.unused.indexOf(frameData.res.key), 1);
        }
    });
};

ViewReader.createTopYAnchorElement = function (data) {
    const content = new cc.Sprite(data.res);
    ViewReader.setTopYAnchorElementData(content, data);
    return content;
};

ViewReader.setTopYAnchorElementData = function (content, data) {
    const width = cleverapps.styles.Map2dView.cell.width;
    const height = cleverapps.styles.Map2dView.cell.height;

    const anchorX = data.options.anchorX !== undefined ? data.options.anchorX : 0.5;
    const anchorY = data.options.anchorY !== undefined ? data.options.anchorY : 1;

    const pos = cc.p(0, 0);
    if (data.options.y !== undefined) {
        pos.y = -height / 2 + data.options.y;
    } else if (anchorY === 0) {
        pos.y = -height / 2;
    } else if (anchorY === 1) {
        pos.y = height / 2 + 1;
    }

    if (data.options.x !== undefined) {
        pos.x = -width / 2 + data.options.x;
    } else if (anchorX === 0) {
        pos.x = -width / 2;
    } else if (anchorX === 1) {
        pos.x = width / 2;
    }

    content.setAnchorPoint(anchorX, anchorY);
    content.setPosition(pos);
};

ViewReader.getUnused = function () {
    return this.unused || [];
};

ViewReader.hasView = function (code) {
    return [Map2d.TILE_WATER, Map2d.TILE_WATER_UNIT, Map2d.TILE_GREEN_LEVEL_1, Map2d.TILE_GREEN_LEVEL_2].indexOf(code) !== -1;
};

ViewReader.parse = function (code, map) {
    const frames = map.getTerrainFrames(Iso.SAME);
    const isOdd = (map.pointer.x + map.pointer.y) % 2;
    let frame, tilesTexture;

    switch (code) {
        case Map2d.TILE_WATER:
        case Map2d.TILE_WATER_UNIT:
            if (code === Map2d.TILE_WATER_UNIT && cleverapps.config.editorMode && frames.water_unit_editor) {
                return Map2dWaterView.GetFromPool(frames.water_unit_editor);
            }
            tilesTexture = Map2d.getTilesTexture(Map2d.currentMap && Map2d.currentMap.tilesSkin);
            frame = bundles[tilesTexture] && bundles[tilesTexture].frames.water;
            return frame ? Map2dWaterView.GetFromPool(frame) : undefined;

        case Map2d.TILE_GREEN_LEVEL_1:
        case Map2d.TILE_GREEN_LEVEL_2:
            if (cleverapps.config.editorMode && frames.green_ground_1_editor) {
                return Map2dGroundView.GetFromPool(isOdd ? frames.green_ground_1_editor : frames.green_ground_2_editor);
            }
            frame = isOdd ? frames.green_ground_1 : frames.green_ground_2;
            return frame ? Map2dGroundView.GetFromPool(frame) : undefined;
        case Map2d.TILE_IMPASSABLE_LEVEL_1:
        case Map2d.TILE_IMPASSABLE_LEVEL_2:
            if (frames.green_ground_3) {
                return Map2dGroundView.GetFromPool(frames.green_ground_3);
            }

            frame = isOdd ? frames.green_ground_1 : frames.green_ground_2;
            return frame ? Map2dGroundView.GetFromPool(frame) : undefined;
        case Map2d.TILE_GROUND_CHESS:
            return Map2dChessGroundView.GetFromPool(isOdd ? frames.chess_1 : frames.chess_2);
        case Map2d.TILE_STARRED_GROUND_CHESS:
            if (cleverapps.config.debugMode) {
                return Map2dChessGroundView.GetFromPool(bundles.dev_resources.frames.chess_debug);
            }
    }
};
